import type { SVGProps } from 'react';
const SvgUserSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" {...props}>
    <path
      fill="currentColor"
      d="M13.5 12.571a4.36 4.36 0 0 0 3.06-1.255 4.251 4.251 0 0 0 0-6.06 4.363 4.363 0 0 0-6.12 0 4.25 4.25 0 0 0 0 6.06c.402.398.88.714 1.404.93a4.4 4.4 0 0 0 1.656.325m-1.07 2c-3.553 0-6.43 2.85-6.43 6.368C6 21.525 6.48 22 7.07 22h12.86c.59 0 1.07-.475 1.07-1.06 0-3.519-2.877-6.369-6.43-6.369z"
    />
  </svg>
);
export default SvgUserSolid;
